var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalloonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.002,
    height: 93.96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff8e6",
    d: "M53.003 93.961a1.38 1.38 0 0 1-1.35-1.113c-1.927-9.837.243-15.422 2.34-20.823a44 44 0 0 0 2.392-7.473 1.377 1.377 0 0 1 2.7.541 46.7 46.7 0 0 1-2.525 7.928c-2.046 5.268-3.978 10.243-2.2 19.3a1.377 1.377 0 0 1-1.087 1.616 1.4 1.4 0 0 1-.27.024",
    "data-name": "Path 1309"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff8e6",
    d: "M40.999 93.964a1.378 1.378 0 0 1-1.353-1.642c1.774-9.054-.159-14.029-2.2-19.3a46.7 46.7 0 0 1-2.525-7.928 1.377 1.377 0 0 1 2.7-.541 44 44 0 0 0 2.392 7.472c2.1 5.4 4.267 10.987 2.34 20.823a1.38 1.38 0 0 1-1.354 1.116",
    "data-name": "Path 1310"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffeab7",
    d: "M25.651 93.961a1.378 1.378 0 0 1-1.353-1.642 30.5 30.5 0 0 0 .351-10.927 1.377 1.377 0 0 1 2.717-.447 33.2 33.2 0 0 1-.366 11.9 1.38 1.38 0 0 1-1.349 1.116",
    "data-name": "Path 1311"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1137"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffeab7",
    d: "M68.352 93.961a1.38 1.38 0 0 1-1.35-1.113 33.2 33.2 0 0 1-.366-11.9 1.377 1.377 0 0 1 2.717.447 30.5 30.5 0 0 0 .351 10.927 1.377 1.377 0 0 1-1.087 1.616 1.4 1.4 0 0 1-.265.023",
    "data-name": "Path 1312"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1139"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fccb88",
    d: "M13.268 36.46C3.583 39.06-2.047 49.451.693 59.679c4.975 18.568 24.323 20.628 24.323 20.628s15.726-11.458 10.751-30.026c-2.741-10.228-12.814-16.416-22.5-13.821Z",
    "data-name": "Path 1313"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a98a",
    d: "M8.863 57.49c-2.343-8.743 1.431-17.607 8.625-21.618a17.3 17.3 0 0 0-4.221.588C3.583 39.055-2.047 49.451.694 59.674c4.975 18.568 24.323 20.628 24.323 20.628a27.5 27.5 0 0 0 3.51-3.24c-6.052-1.86-16.246-6.826-19.663-19.577Z",
    "data-name": "Path 1314"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9ed80",
    d: "M31.133 81.213 20.172 84.15a2.837 2.837 0 1 1-1.469-5.481l10.962-2.937a2.837 2.837 0 0 1 1.469 5.481Z",
    "data-name": "Path 1315"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fccb88",
    d: "M24.918 79.942a2.837 2.837 0 0 1 2.006-3.475l-8.221 2.2a2.837 2.837 0 1 0 1.469 5.481l8.221-2.2a2.837 2.837 0 0 1-3.475-2.006",
    "data-name": "Path 1316"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f89260",
    d: "M80.734 36.46c-9.685-2.6-19.759 3.593-22.5 13.821-4.975 18.568 10.751 30.026 10.751 30.026s19.348-2.06 24.323-20.628c2.741-10.228-2.889-20.624-12.574-23.219",
    "data-name": "Path 1317"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec7033",
    d: "M66.404 52.47c2.343-8.743 10.043-14.532 18.279-14.409a17.3 17.3 0 0 0-3.949-1.6c-9.685-2.6-19.759 3.593-22.5 13.821-4.975 18.568 10.751 30.026 10.751 30.026a27.5 27.5 0 0 0 4.66-1.051c-4.311-4.637-10.657-14.035-7.241-26.786Z",
    "data-name": "Path 1318"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1145"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff97c0",
    d: "m73.83 84.15-10.962-2.937a2.837 2.837 0 1 1 1.469-5.481l10.962 2.937a2.837 2.837 0 0 1-1.469 5.481",
    "data-name": "Path 1319"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff71a7",
    d: "M69.083 79.941a2.837 2.837 0 0 1 3.475-2.006l-8.221-2.2a2.837 2.837 0 1 0-1.469 5.481l8.221 2.2a2.837 2.837 0 0 1-2.006-3.475",
    "data-name": "Path 1320"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6dddeb",
    d: "M74.956.849c-13.9-3.725-28.364 5.157-32.3 19.84-7.142 26.654 15.432 43.1 15.432 43.1s27.774-2.957 34.916-29.611C96.938 19.496 88.857 4.573 74.953.848Z",
    "data-name": "Path 1321"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#51cddd",
    d: "M54.386 23.831C57.749 11.281 68.803 2.97 80.622 3.147a24.8 24.8 0 0 0-5.669-2.3c-13.9-3.725-28.364 5.157-32.3 19.84-7.142 26.654 15.432 43.1 15.432 43.1a39.5 39.5 0 0 0 6.689-1.508c-6.183-6.653-15.293-20.143-10.388-38.448",
    "data-name": "Path 1322"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1149"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#50e1cd",
    d: "m62.935 67.634-10.962-2.937a2.837 2.837 0 0 1 1.469-5.481l10.962 2.937a2.837 2.837 0 1 1-1.469 5.481",
    "data-name": "Path 1323"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00d1b3",
    d: "M58.188 63.425a2.837 2.837 0 0 1 3.475-2.006l-8.221-2.2a2.837 2.837 0 1 0-1.469 5.481l8.221 2.2a2.837 2.837 0 0 1-2.006-3.475",
    "data-name": "Path 1324"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1151",
    transform: "translate(45.715 17.444)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.644,
    cy: 5.832,
    fill: "#fff",
    "data-name": "Ellipse 96",
    rx: 4.644,
    ry: 5.832,
    transform: "rotate(-74.991 5.848 4.487)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1152",
    transform: "translate(76.255 25.625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.644,
    cy: 5.832,
    fill: "#fff",
    "data-name": "Ellipse 97",
    rx: 4.644,
    ry: 5.832,
    transform: "rotate(-74.991 5.848 4.487)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#495560",
    d: "M56.996 21.324a1.378 1.378 0 0 1-1.331-1.734l.588-2.192a1.377 1.377 0 1 1 2.66.713l-.588 2.192a1.38 1.38 0 0 1-1.329 1.021",
    "data-name": "Path 1325"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1155"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#495560",
    d: "M69.717 26.108a5.71 5.71 0 0 1-5.131-3.205 1.377 1.377 0 1 1 2.474-1.21 2.958 2.958 0 0 0 4.313 1.156 1.377 1.377 0 1 1 1.537 2.285 5.7 5.7 0 0 1-3.193.974",
    "data-name": "Path 1326"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#495560",
    d: "M83.943 28.479a1.378 1.378 0 0 1-1.331-1.734 1.253 1.253 0 0 0-2.421-.648 1.377 1.377 0 1 1-2.66-.713 4.007 4.007 0 1 1 7.741 2.074 1.38 1.38 0 0 1-1.329 1.021",
    "data-name": "Path 1327"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f89260",
    d: "M19.046.849C5.142 4.574-2.939 19.497.995 34.179c7.142 26.655 34.916 29.608 34.916 29.608s22.574-16.444 15.432-43.1C47.409 6.006 32.949-2.876 19.046.849",
    "data-name": "Path 1328"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec7033",
    d: "M12.723 31.037C9.36 18.486 14.777 5.767 25.1.004a24.8 24.8 0 0 0-6.059.845C5.142 4.574-2.939 19.496.995 34.179 8.137 60.834 35.911 63.79 35.911 63.79a39.5 39.5 0 0 0 5.039-4.651c-8.688-2.67-23.322-9.8-28.227-28.1Z",
    "data-name": "Path 1329"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed783e",
    d: "m42.028 64.697-10.962 2.937a2.837 2.837 0 1 1-1.469-5.481l10.962-2.937a2.837 2.837 0 1 1 1.469 5.481",
    "data-name": "Path 1330"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd672d",
    d: "M35.813 63.425a2.837 2.837 0 0 1 2.006-3.475l-8.221 2.2a2.837 2.837 0 0 0 1.469 5.481l8.221-2.2a2.837 2.837 0 0 1-3.475-2.006",
    "data-name": "Path 1331"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1162",
    transform: "translate(5.208 25.981)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.558,
    cy: 4.426,
    fill: "#fff",
    "data-name": "Ellipse 98",
    rx: 5.558,
    ry: 4.426,
    transform: "rotate(-15.009 10.927 1.44)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1163",
    transform: "translate(34.31 18.178)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.558,
    cy: 4.426,
    fill: "#fff",
    "data-name": "Ellipse 99",
    rx: 5.558,
    ry: 4.426,
    transform: "rotate(-15.009 10.927 1.44)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#495560",
    d: "M29.716 23.353c-.717-2.675-2.722-2.407-5.113-1.767s-4.261 1.411-3.545 4.086a4.51 4.51 0 1 0 8.657-2.32Z",
    "data-name": "Path 1332"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1166"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#495560",
    d: "M11.245 27.728a1.38 1.38 0 0 1-1.329-1.021l-.588-2.192a1.377 1.377 0 0 1 2.66-.713l.588 2.192a1.378 1.378 0 0 1-1.331 1.734",
    "data-name": "Path 1333"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#495560",
    d: "M38.551 20.412a1.38 1.38 0 0 1-1.329-1.021l-.587-2.192a1.377 1.377 0 1 1 2.66-.713l.587 2.192a1.378 1.378 0 0 1-1.331 1.734",
    "data-name": "Path 1334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonLogo);
export default __webpack_public_path__ + "static/media/balloon-logo.d3425d61f575cc0a5d840c23ea4a68c7.svg";
export { ForwardRef as ReactComponent };